// extracted by mini-css-extract-plugin
module.exports =  {"chartTooltip":"aqN3fy3kEJAwXOztf0Qx","chartsBox":"Ec84O5dw9mTrSGDRYFbL"};